import apiClient from "@/lib/api";
import type {
  AptitudeReport,
  AptitudeResult,
  AptitudeSession,
} from "./types";

export async function startAptitudeSession(
  mode: "mock" | "review",
  sourceSessionId?: string,
) {
  const response = await apiClient.post<AptitudeSession>("/aptitude/sessions", {
    mode,
    source_session_id: sourceSessionId,
  });
  return response.data;
}

export async function getAptitudeSession(id: string) {
  const response = await apiClient.get<AptitudeSession>(`/aptitude/sessions/${id}`);
  return response.data;
}

export async function answerAptitudeItem(
  sessionId: string,
  itemId: string,
  selectedChoiceKey: string,
) {
  const response = await apiClient.post<{
    session: AptitudeSession;
    answered_item: import("./types").AptitudeItem;
  }>(`/aptitude/sessions/${sessionId}/items/${itemId}/answer`, {
    selected_choice_key: selectedChoiceKey,
  });
  return response.data;
}

export async function getAptitudeResult(id: string) {
  const response = await apiClient.get<AptitudeResult>(
    `/aptitude/sessions/${id}/result`,
  );
  return response.data;
}

export async function getAptitudeReport() {
  const response = await apiClient.get<AptitudeReport>("/aptitude/report");
  return response.data;
}
